import { API, graphqlOperation } from "aws-amplify";
import * as mutations from "graphql/mutations";
import {
  listRequiredResolutions,
  getRequiredResolutionByResAndType,
  createRequiredResolution,
  deleteCampaignRequiredResolutions,
} from "services/apiMiddleware";
import _ from "lodash";
import { t } from "../../i18n";

const requiredResolutions = {
  state: {
    isLoading: false,
    error: null,
    items: [],
  },
  reducers: {
    loadStart: (state) => {
      return {
        ...state,
        isLoading: true,
      };
    },
    loadStop: (state) => {
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    },
    loadSuccess: (state, items) => {
      return {
        ...state,
        isLoading: false,
        error: null,
        items,
      };
    },
    createSuccess: (state, newItem) => {
      return {
        ...state,
        isLoading: false,
        error: null,
        items: [...state.items, newItem],
      };
    },
    deleteSuccess: (state, deletedId) => {
      return {
        ...state,
        isLoading: false,
        error: null,
        items: state.items.filter((item) => item.id !== deletedId),
      };
    },
    failure: (state, error) => {
      return {
        ...state,
        isLoading: false,
        error,
      };
    },
  },
  effects: (dispatch) => ({
    async load() {
      try {
        dispatch.requiredResolutions.loadStart();
        const { data, errorMessage } = await listRequiredResolutions();
        dispatch.requiredResolutions.loadSuccess(data);
        if (errorMessage) console.warn(errorMessage);
      } catch (error) {
        console.error(error);
        dispatch.requiredResolutions.failure(
          t("required_resolutions_load_error", { ns: "common" })
        );
      }
    },
    async create(createProps) {
      try {
        dispatch.requiredResolutions.loadStart();
        const { data, errorMessage } = await getRequiredResolutionByResAndType(createProps);
        if (errorMessage) {
          console.warn(errorMessage);
          return; // Return so new required resolution is not created
        }
        // Create new required resolution
        if (!data) {
          const { data, errorMessage } = await createRequiredResolution(createProps);
          if (errorMessage) console.warn(errorMessage);
          dispatch.requiredResolutions.createSuccess(data);
          return data;
        }
        // Return existing required resolution
        dispatch.requiredResolutions.loadStop();
        return data;
      } catch (error) {
        dispatch.requiredResolutions.failure(
          t("required_resolutions_create_error", { ns: "common" })
        );
        throw error;
      }
    },
    async delete(requiredResolution) {
      try {
        dispatch.requiredResolutions.loadStart();

        // First, delete required resolution's items from CampaignRequiredResolution join table
        const campaignRrsToDelete = _.map(requiredResolution.campaigns.items, "id");
        await deleteCampaignRequiredResolutions(campaignRrsToDelete);

        // Then, delete the required resolution
        const result = await API.graphql(
          graphqlOperation(mutations.deleteRequiredResolution, {
            input: { id: requiredResolution.id },
          })
        );
        const deletedId = result.data.deleteRequiredResolution.id;
        dispatch.requiredResolutions.deleteSuccess(deletedId);
      } catch (error) {
        dispatch.requiredResolutions.failure(
          t("required_resolutions_delete_error", { ns: "common" })
        );
        throw error;
      }
    },
  }),
};

export default requiredResolutions;
